import Proxy from "./Proxy"

class EstimateProxy extends Proxy {
  constructor(parameters = {}) {
    super("estimates", parameters)
  }

  allLines(id, ...args) {
    return this.submit("get", `/${this.endpoint}/${id}/lines/`, ...args)
  }

  updateLines(id, items, ...args) {
    return this.submit("post", `/${this.endpoint}/${id}/lines/`, items, ...args)
  }

  duplicate(id, ...args) {
    return this.submit("post", `/${this.endpoint}/${id}/duplicate/`, ...args)
  }
}

export default EstimateProxy
